import React, { useState } from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const BoardSelector = ({ boards, selectedBoard, onBoardChange }) => {
  const boardOptions = [
    { value: 'all', label: 'All Boards' },
    ...boards?.map(board => ({
      value: board?.id,
      label: board?.name,
      description: `${board?.pinCount} pins`
    }))
  ];

  return (
    <div className="flex items-center gap-3">
      <Icon name="LayoutGrid" size={20} className="text-muted-foreground" />
      <Select
        options={boardOptions}
        value={selectedBoard}
        onChange={onBoardChange}
        placeholder="Select board"
        className="w-64"
      />
    </div>
  );
};

export default BoardSelector;